import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { SidebarProvider } from '@deepguide-ai/ui/sidebar'
import { useAtomValue } from 'jotai'
import { NavUser } from '@/components/nav-user'
import { currentUserAtom } from '@/stores/sessionStore'

export const Route = createFileRoute('/(protected)/auditor-center')({
  component: AuditorHomePage,
})

function AuditorHomePage() {
  const { session } = Route.useRouteContext()
  const user = useAtomValue(currentUserAtom) ?? session?.user

  return (
    <SidebarProvider>
      <div className='bg-background flex min-h-screen w-full flex-col'>
        <header className='border-border bg-card flex h-16 shrink-0 items-center justify-between border-b px-6'>
          <Link
            to='/auditor-center'
            className='font-heading text-foreground flex items-center gap-2 text-[16px] font-semibold'
          >
            <img
              src='/logos/screenata-logo-black-on-white.svg'
              alt=''
              className='h-7 w-7 dark:hidden'
            />
            <img
              src='/logos/screenata-logo-white-on-black.svg'
              alt=''
              className='hidden h-7 w-7 dark:block'
            />
            Screenata
          </Link>
          <div className='ml-auto w-8 shrink-0'>
            <NavUser
              compact
              user={
                user
                  ? {
                      ...user,
                      name: user.name || user.email,
                      image: user.image || '',
                    }
                  : null
              }
            />
          </div>
        </header>
        <main className='mx-auto w-full max-w-7xl flex-1'>
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  )
}
